import {useListView} from '../../core/ListViewProvider'
import {UsersListToolbar} from './UserListToolbar'
import {UsersListGrouping} from './UsersListGrouping'
import {UsersListSearchComponent} from './UsersListSearchComponent'

interface userProps {
  csvDownload?: boolean
  onCsvDownload?: () => void
  label?: string
  placeholder?: string
  searchElements?: any
  showResetButton?: boolean
  initialApi?: any
  showDownload?: boolean
  showPayNow?: boolean
  downloadViewLabel?: string
  secondLabel?: boolean
}

const UsersListHeader = ({
  label = '',
  showResetButton = false,
  placeholder,
  searchElements = [],
  initialApi = '',
  showDownload = false,
  downloadViewLabel = '',
  showPayNow = false,
  secondLabel = false,
  csvDownload = false,
  onCsvDownload,
}: userProps) => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0'>
      <UsersListSearchComponent
        showPayNow={showPayNow}
        showDownload={showDownload}
        downloadViewLabel={downloadViewLabel}
        showResetButton={showResetButton}
        searchElements={searchElements}
        placeholder={placeholder}
        initialApi={initialApi}
        csvDownload={csvDownload}
        onCsvDownload={onCsvDownload}
      />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <UsersListGrouping /> : <UsersListToolbar />}
        <UsersListToolbar label={label} secondLabel={secondLabel} />
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {UsersListHeader}
